import { render, staticRenderFns } from "./VisualizarMovi.vue?vue&type=template&id=d636dc92&"
import script from "./VisualizarMovi.vue?vue&type=script&lang=js&"
export * from "./VisualizarMovi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports